export const WORKOUT_ATTRIBUTES = {
  MUSCLE_GROUP: 1,
  EQUIPMENT: 2,
  TRAINING_STYLE: 3,
  GOAL_OUTCOME: 4,
} as const;

export type WorkoutAttributeType = typeof WORKOUT_ATTRIBUTES[keyof typeof WORKOUT_ATTRIBUTES];

export const WORKOUT_DURATION = {
  FIVE_MINS: 1,
  TEN_MINS: 2,
  TWENTY_MINS: 3,
  THIRTY_MINS: 4,
  FORTY_MINS: 5,
  SIXTY_MINS: 6
} as const;

export const DIFFICULTY_LEVEL = {
BEGGINER: 1,
INTERMEDIATE: 2,
ADVANCED: 3,
BEGINNER_INTERMEDIATE: 4,
} as const;

export const VISIBILITY_SCOPE = {
  DEMAND: 1,
  PROGRAM: 2,
  BOTH: 3
} as const;

export const NAME_LIMIT = 25;



export const WEEKLY_PROGRAM_STATUS = {
  LOCK: 1,
  UNLOCK: 2,
} as const;
